import { Services } from '@sigma-frontend-libs/commons'
import { BILLING_CURRENCY } from '@sigma-legacy-libs/essentials/lib/constants'

import { currentTab, permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [
    proxy({ type: 'object' }),
    currentTab('general')
  ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },

    saveSuccessKey: {
      type: Number,
      default: 0
    }
  },

  computed: {
    accountCurrency() {
      return this.account?.settings?.['billings.currency']
    },

    tabs() {
      const result = [ 'general', Services.settingsUser, Services.tariffs ]
      const generalServices = [ Services.tokens ]
      for (const service of generalServices) {
        if (this.checkPermissions(`advanced.${service}.get`, permissionPresets.meUp)) {
          result.push(service)
        }
      }
      if (this.accountCurrency === BILLING_CURRENCY.RUB) {
        const servicesForRUBCurrency = [
          Services.requisites,
          Services.recurrentPayments
        ]
        for (const service of servicesForRUBCurrency) {
          if (this.checkPermissions(`advanced.${service}.get`, permissionPresets.meUp)) {
            result.push(service)
          }
        }
        if (this.checkPermissions(`advanced.${Services.billings}.find`, permissionPresets.meUp)) {
          result.push('referral')
        }
      }

      return result
    }
  },

  render
}
